const { createSelector } = require('reselect');
const userUtils = require('utils/User');
const { userSelector } = require('selectors/user/userSelector');

const isAnonymousSelector = createSelector(userSelector, user => userUtils.isAnonymous(user));

module.exports = { isAnonymousSelector };
